import i18n from 'i18next'
import { divide, times } from 'number-precision'
import * as XLSX from 'xlsx-js-style'
import { errorCodeToMessage, ErrorMessage } from './messages'

export const getTranslation = (text) => i18n.t(text)

export const getTranslatedErrorMessage = (errorCode) => {
  const errorMessage =
    errorCodeToMessage.get(errorCode) || ErrorMessage.internalServerError
  return getTranslation(errorMessage)
}

export const exportToXLSX = (data, columns, fileName = 'reports') => {
  // STEP 1: Create a new workbook
  const wb = XLSX.utils.book_new()

  // STEP 2: Create data rows and styles
  columns = columns.map(c => ({ v: c, s: { font: { bold: true } } }))
  const newData = [columns, ...data.map((x) => {
    return Object.values(x).map(v => ({
      v
    }))
  })]
  // STEP 3: Create worksheet with rows; Add worksheet to workbook
  const ws = XLSX.utils.json_to_sheet(newData, { skipHeader: true })
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
  ws['!cols'] = Array(data.length).fill({ wch: 20 })
  // STEP 4: Write Excel file to browser
  XLSX.writeFile(wb, `${fileName}.xlsx`)
}

export const getNumToStringPrecision = (input = 0, precision = 8) => {
  precision = precision
  if (typeof input === 'number') {
    const factor = Math.pow(10, precision)
    input = divide(Math.trunc(times(input, factor)), factor)
    input = input.toFixed(precision)
  }

  let str = String(input)

  if (/^[0.]+$/.test(str)) {
    // Only zeros and decimal
    return str
  }

  // Remove only trailing zeros after decimal
  return str.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, '')
}
